import { Container } from "./style";
import { addComma } from "../../utils/Utils";
import AddOnViewModel from "./add-on.viewmodel";


export default function AddOnPage() {

  const viewModel = AddOnViewModel();

  return (
    <Container>
      {viewModel.isPaying && <div className="pg_overlay" />}
      <div className="inner">
        <p className="page_title"><span>추가자문료 결제하기</span></p>

        <div className="bx product">
          <div className="bx_ttl flex">
            <p className="form_label">상품 선택</p>
            <p className="form_label flex ai-c column flex1">
              <span>결제금액</span>
              <span className="green">({viewModel.period === null ? '' :  viewModel.period === -1 ? '특별자문료 구독' : `${viewModel.period}개월 구독 중`})</span>
            </p>
          </div>
          <ul>
            {viewModel.addOnList.map((addOn, index) => (
              <li key={`addOn${index}`}>
                <button
                  className={`outlined_gray${addOn.isSelected ? ' active' : ''}`}
                  onClick={() => viewModel.toogleAddOn(addOn)}
                  disabled={addOn.disable}
                >{addOn.name}</button>
                <p>{addComma(addOn.price)}원</p>
              </li>
            ))}
            {/* <li>
              <button
                className={`outlined_gray${false ? ' active' : ''}`}
                onClick={() => {}}
              >특별자문료</button>
              <p>000,000원</p>
            </li> */}
          </ul>
        </div>

        <div className="bx payment_amount">
          <p className="form_label">총 결제금액</p>
          <p className="price">
            <strong className="fs20 green">{addComma(viewModel.userCoupon !== null ? Math.max(0, viewModel.amount - viewModel.userCoupon.coupon.value) : viewModel.amount)}</strong>
            <span className="gray_9a"> (VAT 별도)</span>
            {viewModel.userCoupon !== null && (
              <>
              <span> = </span>
              <span className="fs16">{addComma(viewModel.amount)}</span>
              <span className="gray_9a"> (VAT 별도)</span>
              <span> - </span>
              <span className="fs16">{addComma(viewModel.userCoupon.coupon.value)}</span>
              <span className="green"> (쿠폰 할인)</span>
              </>
            )}
          </p>
          {((viewModel.addOnList.map(v => v.isSelected).find(v => v === true)) && (viewModel.addOnList.filter(v => v.isSelected).map(v => v.price).reduce((a, c) => a + c, 0) === 0) )&& (
            <p className="msg">결제금액이 무료인 서비스만 제공을 원하는 경우, 아래 결제하기 없이 바로 상담신청 바랍니다.</p>
          )}
          {viewModel.disable && (
            <p className="msg">정기자문료 구독일로부터 2개월 도과하여야 추가자문료 결제가 가능합니다.</p>
          )}
        </div>


        <div className="bx payment_type">
          <p className="form_label">결제 방법</p>
          <div className="flex">
            <button
              className={`outlined_gray${viewModel.payMethod === 0 ? ' active' : ''}`}
              onClick={() => viewModel.setPayMethod(0)}
            >신용카드</button>
            <button
              className={`outlined_gray${viewModel.payMethod === 1 ? ' active' : ''}`}
              onClick={() => viewModel.setPayMethod(1)}
            >휴대폰 결제</button>
          </div>
        </div>
        

          <button className="contained_main btn_done fs16"
            disabled={viewModel.amount === 0}
            onClick={viewModel.order}
          >결제하기</button>
      </div>
    </Container>
  )
}